<template>
  <div id="roomtype">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li>
          <a href="#/myprojects">My Projects</a>
        </li>
        <li>
          <a :href="'#/project/' + roomtype.project[0]._id">{{
            roomtype.project[0].name
          }}</a>
        </li>
        <li class="active">{{ roomtype.name }}</li>
      </ol>
    </div>
    <div class="content project middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <div class="row">
            <div
              class="col-xs-12 col-sm-8 col-sm-offset-2"
              style="margin-bottom: 100px"
            >
              <p class="sub-title text-center">
                {{ roomtype.project[0].name }}
              </p>
              <p class="text-center mt30 font15">
                <span>{{ roomtype.name }}</span>
              </p>
              <router-link
                  :to="'/addproduct-keypad/' + $route.params.rid"
                  v-if="canEdit"
                  class="mr30"
                >
                <span class="iconfont2 icon-g7 button-icon font36"></span>
                <span class="font18 black text-middle">Add Keypad</span>
              </router-link>
              <router-link
                  :to="'/addproduct-accessories/' + $route.params.rid"
                  v-if="canEdit"
                >
                <span class="iconfont2 icon-g7 button-icon font36"></span>
                <span class="font18 black text-middle">Add Accessories</span>
              </router-link>
              <h5 class="mt30" style="border-bottom:1px solid #999">KEYPADS</h5><br>
              <div class="roomtype-grid">
                <div
                  class="product-box"
                  v-for="(i, index) in productList"
                  :key="index"
                >
                  <div
                    class="img-box p20"
                    :class="{ 'img-box-vertical' : i.artwork.format.substring(0,1).includes('v') }"
                    :style="{
                      backgroundImage:
                        'url(' + checkImg(i.artwork.img) + ')',
                    }"
                  ></div>
                  <p class="font18 mt20">
                    {{ i.artwork.name }}
                  </p>
                  <div class="row editbox">
                    <div class="col-xs-5" style="padding-right: 0px">
                      <p class="showPcs1 pcs" v-show="!isshow">
                        <span class="mr10">QTY</span>
                        {{ i.quantity }}
                      </p>
                      <p class="editPcs1" v-show="isshow">
                        <span class="mr10">QTY</span>
                        <input
                          type="number"
                          min="1"
                          style="width: 50%"
                          @change="editProductQuantity(i)"
                          v-model="i.quantity"
                          :disabled="!canEdit"
                        />
                      </p>
                    </div>
                    <div class="col-xs-7 text-right" style="padding-left: 0px">
                      <a
                        class="black mr10"
                        v-if="canEdit && !isArtworkObsolete(i.artwork)"
                        @click="artworkEdit(i._id)"
                      >
                        <span class="iconfont3 icon-edit font20"></span>
                      </a>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Download PDF"
                        placement="bottom"
                        v-if="$store.getters.canDownloadFile('PDF')"
                      >
                        <router-link
                          class="black mr10"
                          :to="
                            '/pdfPreview/p' +
                            i._id +
                            '/' +
                            encodeURIComponent(roomtype.project[0].name) +
                            '/' +
                            encodeURIComponent(roomtype.name) +
                            '/' +
                            i.quantity +
                            '?c=' + $store.state.downloaderBrodcastId
                          "
                          target="_blank"
                        >
                          <span
                            class="iconfont3 icon-pdf_smallicon font20"
                          ></span>
                        </router-link>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Download DXF"
                        placement="bottom"
                        v-if="$store.getters.canDownloadFile('DXF') && i.artwork.type != 'blackjack'"
                      >
                        <a
                          class="black mr10"
                          @click="startDownloadDXF(i.artwork)"
                        >
                          <span
                            class="iconfont3 icon-dxf_smallicon font20"
                          ></span>
                        </a>
                      </el-tooltip>
                      <a
                        class="black"
                        v-if="canEdit"
                        @click="delete_product(i.artwork.name, i._id)"
                      >
                        <span class="iconfont3 icon-delete font20"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <h5 class="mt30" style="border-bottom:1px solid #999">ACCESSORIES</h5><br>
              <div class="roomtype-grid">
                <div
                  class="product-box"
                  v-for="(i, index) in accessoriesList"
                  :key="index"
                >
                  <div
                    class="img-box p20"
                    :style="{
                      backgroundImage:
                        'url(images/collection/accessories/' + i.code + '.png)',
                    }"
                  ></div>
                  <p class="font18 mt20">
                    {{ i.code }}
                  </p>
                  <div class="row editbox">
                    <div class="col-xs-5" style="padding-right: 0px">
                      <p class="editPcs1">
                        <span class="mr10">QTY</span>
                        <input
                          type="number"
                          min="1"
                          style="width: 50%"
                          @change="editAccessoryQuantity(i)"
                          v-model="i.quantity"
                          :disabled="!canEdit"
                        />
                      </p>
                    </div>
                    <div class="col-xs-7 text-right" style="padding-left: 0px">
                      <a
                        class="black"
                        v-if="canEdit"
                        @click="deleteAccessory(i)"
                      >
                        <span class="iconfont3 icon-delete font20"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../assets/css/project.css";
import isArtworkObsolete from "../mixins/isArtworkObsoleteMixin"
import checkSpecialChars from "../mixins/checkSpecialChars";

export default {
  name: "roomtype",
  mixins: [isArtworkObsolete,checkSpecialChars],
  data() {
    return {
      roomtype: { project: [{ name: "", _id: "" }] },
      productList: null,
      accessoriesList: null,
      rname: "",
      isshow: true,
      loading: false,
      DownloaderBroadCast : new BroadcastChannel(this.$store.getters.downloaderBroadcastChannel())
    };
  },
  mounted() {
    this.getProductList();
    this.getAccessoriesList();
    this.getRoomtype();
  },
  computed: {
    canEdit() {
      var erp_document_no = this.roomtype.project[0].erp_document_no;
      if (
        typeof erp_document_no != "undefined" &&
        erp_document_no != null &&
        erp_document_no != ""
      ) {
        if (this.$store.state.user.type == "admin") {
          return true;
        }
        return false;
      }
      return true;
    },
  },
  methods: {
    downloadDXF(artwork) {
      this.DownloaderBroadCast.postMessage({ type: "initiateDownload", id: `dxf_${artwork._id}`, fileType: "dxf", fileName: "", data: artwork });
    },
    startDownloadDXF: function (artwork) {
      if (this.containsSpecialChars(artwork)) {
        this.$msgbox({
        title: "ATTENTION",
        message: "A non supported char has been detected – this artwork need to be manually approved and/or modified by our Artwork Team",
        showCancelButton: true,
        confirmButtonText: "Proceed wih download",
        cancelButtonText: "Cancel",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.downloadDXF(artwork);
          } 
          done();
        },
      });
      } else {
        this.downloadDXF(artwork);
      }
     
    },
    checkImg(img) {
      if (typeof img == "undefined") return;
      if (img.includes("data:image")) {
        return img;
      } else {
        return (
          this.$store.state.serverURL + "/artwork/" + img + "?" + Date.now()
        );
      }
    },
    artworkEdit(product_id) {
      if (!this.canEdit) {
        return;
      }
      this.$router.push({
        path: "/collection/engraving/p" + product_id,
      });
    },
    editProductQuantity(product) {
      if (!this.canEdit) {
        return;
      }
      if (isNaN(product.quantity) || product.quantity < 1) {
        this.$message({
          type: "error",
          message: "Enter quantity!",
        });
        return;
      }
      axios
        .put("/product/" + product._id, {
          quantity: product.quantity,
          rid: product.rid
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Quantity changed!",
            });
            this.getProductList();
          } else {
            this.$message({
              type: "error",
              message: "Change Failed!",
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    editAccessoryQuantity(assessory) {
      if (!this.canEdit) {
        return;
      }
      if (isNaN(assessory.quantity) || assessory.quantity < 1) {
        this.$message({
          type: "error",
          message: "Enter quantity!",
        });
        return;
      }
      axios
        .put("/accessories/" + assessory._id, {
          quantity: assessory.quantity,
          rid: assessory.rid
        })
        .then((res) => {
          if (res.data.ok == 1) {
            this.$message({
              type: "success",
              message: "Quantity changed!",
            });
            this.getAccessoriesList();
          } else {
            this.$message({
              type: "error",
              message: "Change Failed!",
            });
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    getRoomtype() {
      axios
        .get("/roomtype/single/" + this.$route.params.rid)
        .then((response) => {
          this.roomtype = response.data[0];
        }); 
    },
    getProductList() {
      this.loading = true;
      axios.get("/product/" + this.$route.params.rid).then((response) => {
        this.productList = response.data;
        this.loading = false;
      });
    },
    getAccessoriesList() {
      this.loading = true;
      axios.get("/accessories/room/" + this.$route.params.rid).then((response) => {
        this.accessoriesList = response.data;
        this.loading = false;
      });
    },

    delete_product(name, ID) {
      if (!this.canEdit) {
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE PRODUCT",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, name + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.loading = true;
            axios
              .delete("/product/" + ID)
              .then((res) => {
                if (res.data.ok == 1) {
                  instance.confirmButtonLoading = false;
                  done();
                  this.$message({
                    type: "success",
                    message: "Delete Successfully!",
                  });

                  this.getProductList();
                } else {
                  instance.confirmButtonLoading = false;
                  done();
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch(function (error) {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },

    deleteAccessory(accessory) {
      if (!this.canEdit) {
        return;
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE ACCESSORY",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, accessory.code + "?"),
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.loading = true;
            axios
              .delete("/accessories/" + accessory._id)
              .then((res) => {
                if (res.data.ok == 1) {
                  instance.confirmButtonLoading = false;
                  done();
                  this.$message({
                    type: "success",
                    message: "Delete Successfully!",
                  });

                  this.getAccessoriesList();
                } else {
                  instance.confirmButtonLoading = false;
                  done();
                  this.$message({
                    type: "error",
                    message: "Delete Failed!",
                  });
                }
              })
              .catch(function (error) {
                window.console.log(error);
              });
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>
